import { useOptimizationRunner } from '@e2m-customer-portal/hooks';
import { Button } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useToggle } from 'react-use';

interface OptimizationRunnerProps {
  id: string;
}

export function OptimizationRunner({ id }: Readonly<OptimizationRunnerProps>): ReactElement<OptimizationRunnerProps> {
  const [t] = useTranslation();

  const runOptimization = useOptimizationRunner(id);
  const [cooldown, toggleCooldown] = useToggle(false);

  return (
    <Button
      className="disabled:bg-white/50"
      disabled={cooldown}
      onClick={() => {
        runOptimization();
        toggleCooldown();
        setTimeout(toggleCooldown, 3000);
      }}
    >
      {t('COPT_OPTIMIZATION_RUN_NOW')}
    </Button>
  );
}
